import React, { useState } from "react";
import "./Quality_Management_Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

/* ================= MENU DATA ================= */
const QUALITY_MENU = {
  general: [
    { label: "Imperiality", Link: "general-requirement/imperiality" },
    { label: "Confidentiality", Link: "general-requirement/confidentiality" },
  ],

  structural: [
    { label: "Legal Entity", Link: "structural-requirement/legel-entity" },
    {
      label: "Organization Chart",
      Link: "structural-requirement/organization-chart",
    },
    { label: "Quality Policy", Link: "structural-requirement/quality-policy" },
    { label: "Objectives", Link: "tructural-requirement/objectives" },
    {
      label: "Management Data",
      children: [
        {
          label: "Scope of the Laboratory",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/scope-of-the-laboratory",
        },
        {
          label: "Quality Manual",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/quality-manual",
        },
        {
          label: "Procedure Manual",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/procedure-manual",
        },
        {
          label: "IS Standard",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/is-standard",
        },
        {
          label: "SOP",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/sop",
        },
      ],
    },
  ],

  resource: [
    {
      label: "Personnel Details",
      Link: "resource-requirement/personnel-details",
    },
    {
      label: "Environment Condition",
      Link: "resource-requirement/environment-condition",
    },
    { label: "Equipments", Link: "resource-requirement/equipments" },
    {
      label: "Metrological traceability",
      Link: "resource-requirement/metrological-traceability",
    },
    {
      label: "Externally Provided Product & Service",
      Link: "resource-requirement/externally-service",
    },
  ],

  process: [
    {
      label: "Review of Request, Tenders and Contract",
      Link: "process-requirement/review-contract",
    },
    {
      label: "Selection Verification & Validation of Method",
      Link: "process-requirement/selection-method",
    },
    { label: "Quality Control Plan", Link: "process-requirement/quality-plan" },
    {
      label: "Handling of Test or Calibration Item",
      Link: "process-requirement/handling-item",
    },
    {
      label: "Measurement Uncertainty",
      Link: "process-requirement/measurement-uncertainty",
    },
    {
      label: "Ensuring the Validity of Results",
      Link: "process-requirement/ensuring-results",
    },
    { label: "Complaints", Link: "process-requirement/Complaints" },
    { label: "Non Confirming Work", Link: "process-requirement/non-work" },
  ],
};

const MENU_HEADER_LINKS = {
  managementRequirement: "/quality/management",
};

const Quality_Management_Sidebar = () => {
  const [openMenu, setOpenMenu] = useState("general");
  const [openManagement, setOpenManagement] = useState(true);
  const [activeSub, setActiveSub] = useState("");

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? "" : menu);
  };

  const renderSubMenu = (menuKey) => (
    <div className="submenu">
      {QUALITY_MENU[menuKey].map((item, index) => {
        if (item.children) {
          return (
            <div className="submenu_group" key={index}>
              <button
                className={`submenu_item has_child menu_header ${
                  openManagement ? "active" : ""
                }`}
                onClick={() => setOpenManagement(!openManagement)}
              >
                {item.label}
                <span className="arrow">
                  <FontAwesomeIcon
                    icon={openManagement ? faAngleDown : faAngleRight}
                  />
                </span>
              </button>

              {openManagement && (
                <div className="nested_submenu">
                  {item.children.map((child, i) => (
                    <Link to={child.Link} key={i}>
                      <button
                        className={`submenu_item nested ${
                          activeSub === child.Link ? "active" : ""
                        }`}
                        onClick={() => setActiveSub(child.Link)}
                      >
                        {child.label}
                      </button>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        }

        return (
          <Link to={item.Link} key={index}>
            <button
              className={`submenu_item ${
                activeSub === item.Link ? "active" : ""
              }`}
              onClick={() => setActiveSub(item.Link)}
            >
              {item.label}
            </button>
          </Link>
        );
      })}
    </div>
  );

  return (
    <aside className="common_sidemenu">
      {Object.keys(QUALITY_MENU).map((menu) => (
        <div className="menu_section" key={menu}>
          <button
            className={`menu_header ${openMenu === menu ? "active" : ""}`}
            onClick={() => toggleMenu(menu)}
          >
            {menu.charAt(0).toUpperCase() + menu.slice(1)} Requirement
            <span className="arrow">
              <FontAwesomeIcon
                icon={openMenu === menu ? faAngleDown : faAngleRight}
              />
            </span>
          </button>

          {openMenu === menu && renderSubMenu(menu)}
        </div>
      ))}
      <Link to="management-system-requirement">
      <div className="menu_section">
        <button className={"menu_header "}>
          Management System Requirement
        </button>
      </div>
      </Link>
    </aside>
  );
};

export default Quality_Management_Sidebar;
